// extracted by mini-css-extract-plugin
export default {"HR":"HrText_HR__G3vXT","HRLine":"HrText_HRLine__K08zu","HRText":"HrText_HRText__WWpRN"};